import { IStandardConfigurationDetail } from '../../interfaces/istandard-configuration-detail';
import { CostCodeCostTypeProjectCombination } from '../cost-code-cost-type-project-combination';
import { ResourceCategory } from '../resource-category';
import { StandardConfiguration } from '../standard-configuration';

export class StandardConfigurationDetailBase {
  StandardConfigurationDetailId: number;
  StandardConfigurationId: number;
  ResourceCategoryId: number | null;
  Quantity: number | null;
  CostCodeCostTypeProjectCombinationId: number | null;
  Amount: number | null;
  IsActive: boolean | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  CostCodeCostTypeProjectCombination?: CostCodeCostTypeProjectCombination;
  ResourceCategory?: ResourceCategory;
  StandardConfiguration?: StandardConfiguration;

  constructor(item?: IStandardConfigurationDetail) {
    if (item) {

      this.StandardConfigurationDetailId = item.StandardConfigurationDetailId;
      this.StandardConfigurationId = item.StandardConfigurationId;
      this.ResourceCategoryId = item.ResourceCategoryId;
      this.Quantity = item.Quantity;
      this.CostCodeCostTypeProjectCombinationId = item.CostCodeCostTypeProjectCombinationId;
      this.Amount = item.Amount;
      this.IsActive = item.IsActive;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.CostCodeCostTypeProjectCombination = new CostCodeCostTypeProjectCombination(item.CostCodeCostTypeProjectCombination);
      this.ResourceCategory = new ResourceCategory(item.ResourceCategory);
      this.StandardConfiguration = new StandardConfiguration(item.StandardConfiguration);
    }
  }
}